<section class="container">
    <a href="https://www.un.org/sustainabledevelopment/es/sustainable-development-goals/">
        <p>ODS – Objetivos de Desarrollo Sostenible – ONU – Agenda 2030</p>
    </a>
    <div>
        <a target="_blank" *ngFor="let n of ods" [href]="n.url">
            <img [src]="n.image">
        </a>
    </div>
</section>